import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { getPreFillableFormOrganizationOptions } from '@dealstack/frontend/shared/dataExchange/services/god.service.ts';

/** Sponsor organisations a pre-fillable form can be assigned to, as select options. */
export const usePreFillableFormOrganizationOptions = () => {
	const { data } = useQuery({
		queryKey: [API_PATHS.GODMODE_PRE_FILLABLE_FORM_TEMPLATE_ORGANIZATIONS_GET],
		queryFn: ({ signal }) =>
			getPreFillableFormOrganizationOptions(
				API_PATHS.GODMODE_PRE_FILLABLE_FORM_TEMPLATE_ORGANIZATIONS_GET,
				signal
			),
	});

	return useMemo(
		() =>
			(data?.payload ?? []).map((organization) => ({
				value: organization.id,
				label: organization.name,
			})),
		[data?.payload]
	);
};
